import { HStack as ChakraHStack, Stack as ChakraStack } from '@chakra-ui/react'

export const Stack = ChakraStack
export const HStack = ChakraHStack
